const styles = theme => ({
  navMenuDropdown: {
    minWidth: '180px',
    padding: '8px',
    borderRadius: '10px',
    border: '1px solid #EBEEF3',
    boxShadow: 'none',
  },
  menuList: {
    padding: '0px',
    '& .MuiListItem-root': {
      padding: '16px 12px',
      '&:nth-child(1)': {
        border: 'none',
      },
      '&:hover': {
        background: 'none',
        color: theme.palette.primary.main,
      },
    },
    '& li': {
      gap: '6px',
    },
    '& li img': {
      width: '16px',
      height: '16px',
    },
  },
  singleDownloadBtn: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF !important',
    border: 'none !important',
    width: '100%',
    padding: '16px 24px',
    fontSize: '16px',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&>span': {
      gap: '8px',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  dropDownDownloadBtn: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF !important',
    border: 'none !important',
    width: '100%',
    borderRadius: '4px',
    padding: '9px 20px',
    fontSize: '16px',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
    },
  },
  grayBox: {
    backgroundColor: theme.palette.primary.grey,
    padding: '12px',
    rowGap: '20px',
    flexDirection: 'column',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  gratTextColor: {
    color: '#8C9099',
  },
  fontWeight600: {
    fontWeight: '600',
    fontSize: '14px',
  },
  copyRightEvent: {
    marginLeft: '10px',
  },
  container: {
    maxWidth: '1250px',
    margin: '0 auto',
    padding: '0 16px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  downloadBtnsWrapper: {
    gap: '16px',
  },
  statusesWrapper: {
    display: 'flex',
    gap: '12px',
  },
  btnWrapper: {
    padding: '0px',
  },
  btnV2Styles: {
    borderRadius: '0px !important',
    '& img': {
      width: '16px',
      height: '16px',
      marginRight: '8px',
    },
  },
  errorMessage: {
    marginBottom: '10px',
  },
  taskStatusText: {
    color: theme.palette.secondary.dim,
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginRight: '6px',
    },
  },
  itemsCenter: {
    alignItems: 'center',
  },
  main: { padding: '26px 0' },
  [theme.breakpoints.down('sm')]: {
    main: { padding: '0 0 82px' },
    container: {
      padding: '0',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap !important',
  },
  FeedbackRejectionHolderOwner: {
    padding: '16px',
    border: '1px solid #FFAB2D',
    color: '#342D3D',
    borderRadius: '10px',
    marginBottom: '16px',
    '& h6': {
      color: '#A76708',
      fontWeight: '500',
      marginBottom: '8px',
    },
    '& ul': {
      marginTop: '0',
      padding: '0 10px 0 30px',
    },
  },
  TerminateBtn: {
    fontSize: '16px',
    color: '#342D3D',
    height: '48px',
    minWidth: '151px',
    border: '1px solid #342D3D',
    textTransform: 'none',
    marginRight: '16px',
    borderRadius: '10px',
    transition: 'none',
    '&:hover': {
      background: '#342D3D',
      color: '#fff',
    },
  },
  modalAccptBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '48px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '10px',
    '&:hover': {
      background: '#c02b42',
    },
  },
  innerModalAccept: {
    position: 'relative',
    '& $crossIconimg': {
      position: 'absolute',
      right: '0',
      top: '0',
    },
    '& h1': {
      marginBottom: '24px',
      fontSize: '20px',
    },
    '& h2': {
      marginBottom: '28px',
      fontWeight: '400',
      fontSize: '16px',
    },
  },
  crossIconimg: {
    cursor: 'pointer',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
  },
  Title: {
    fontWeight: '600',
    marginBottom: '0',
    fontSize: '16px',
  },
  headsubtitle: {
    fontSize: '14px',
    fontWeight: '600',
  },
  breadcrumbsHolder: {
    padding: '0 0 30px',
    display: 'flex',
    alignItems: 'center',
    '& $serviceid': {
      marginLeft: 'auto',
    },
  },
  serviceid: {},
  breadcrumbs: {
    fontSize: '12px',
    '& li': {
      padding: '0',
      border: '0',
    },
    '& a': {
      color: '#1C999B',
      textDecoration: 'none',
      '& svg': {
        fontSize: '18px',
      },
    },
    '& $activelink': {
      color: '#8C9099',
    },
  },
  activelink: {},
  routerLink: {
    textDecoration: 'none',
  },
  paperCardFrame: {
    marginBottom: '7px',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      border: '0',
    },
  },
  innerCardGrid: {
    padding: '16px',
    '& h6': {
      fontSize: '14px',
    },
  },
  strongText: {
    fontSize: '14px',
    fontWeight: '600',
  },
  initiateserviceSect: {
    marginBottom: '4px',
    padding: '0 15px',
  },
  mainBtnholdaer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: '22px',
    '& $btnHolder': {
      minWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        minWidth: '197px',
      },
    },
  },
  btnHolder: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '& $downloadBtnoutline:not(:first-of-type)': {
      marginTop: '10px',
    },
  },
  primary: {
    // backgroundColor: '#D2374F !important',
    color: '#FFFFFF !important',
    border: 'none !important',
  },
  downloadBtnoutline: {
    width: '100%',
    border: '1px solid #342D3D',
    color: '#342D3D',
    // background: 'transparent',
    fontWeight: '600',
    fontSize: '16px',
    padding: '16px 24px',
    borderRadius: '0px',
    textTransform: 'none',
    '&:hover': {
      border: '1px solid #342D3D',
      // background: 'transparent',
    },
    '& img': {
      marginRight: '5px',
    },
    '& svg': {
      marginRight: '5px',
      fontSize: '19px',
    },
  },
  paymentReceiptDownloadBtn: {
    marginTop: '12px',
  },
  initiatedByDiscription: {
    paddingTop: '5px',
    color: '#8C9099',
    fontSize: '12px',
    fontWeight: '500',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    '& p': {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  initiatedByHolder: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: '5px',
      flexShrink: '0',
    },
  },
  // warning: {
  //   color: theme.palette.primary.warningMango,
  //   border: `1px solid ${theme.palette.primary.warningMango}`,
  //   background: theme.palette.primary.warningMangoLight,
  // },
  pendingLabel: {
    minWidth: '74px',
    fontSize: '12px',
    fontWeight: '500',
    marginBottom: '8px',
    color: '#484456',
    '& span': {
      overflow: 'visible',
    },
  },
  draftsLabelBG: {
    backgroundColor: '#F8F8F8',
    color: '#484456',
    border: '1px solid #CED1D6',
  },
  inProgLabelBG: {
    backgroundColor: '#EBF7FF',
    color: '#0496FF',
    border: '1px solid #0496FF',
  },
  cancelledLabelBG: {
    backgroundColor: '#CED1D6',
    color: '#484456',
    border: '1px solid #484456',
  },
  completedLabelBG: {
    backgroundColor: '#EDFDF9',
    color: '#12B78E',
    border: '1px solid #12B78E',
  },
  rejectedLabelBG: {
    backgroundColor: '#FFEBEE',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
  pendingLabelBG: {
    backgroundColor: theme.palette.primary.main,
  },
  submittedLabelBG: {
    backgroundColor: theme.palette.primary.adgmGreen,
  },
  warrningMessage: {
    color: '#0496FF',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    fontSize: '12px',
    '& svg': {
      marginRight: '4px',
      fontSize: '16px',
    },
  },
  draftsMessageBG: { color: '#484456' },
  submittedMessageBG: { color: theme.palette.primary.adgmGreen },
  inProgMessageBG: { color: '#0496FF' },
  completedMessageBG: { color: '#12B78E' },
  pendingMessageBG: { color: theme.palette.primary.main },
  rejectedMessageBG: { color: theme.palette.primary.adgmRed },
  RETURNEDMessageBG: { color: theme.palette.primary.main },
  cancelledMessageBG: { color: '#484456' },
  dmtReviewMessageBG: { color: '#0496FF' },
  notificationArea: {
    border: '1px solid #CED1D6',
    padding: '12px',
    marginBottom: '12px',
    '& p': {
      fontSize: '14px',
    },
    '& $adgmRedBtn': {
      marginTop: '8px',
      display: 'flex',
      width: '100%',
    },
  },
  notificationbar: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    '& p': {
      fontWeight: '600',
      fontSize: '14px',
    },
    '& svg': {
      marginRight: '8px',
      width: '24px',
    },
  },
  adgmRedBtn: {
    background: theme.palette.primary.main,
    color: '#fff',
    fontWeight: '600',
    fontSize: '14px',
    textTransform: 'none',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    padding: '10px 15px',
    '&:hover': {
      background: '#0088FF',
      textDecoration: 'none',
    },
  },
  mobiletitlehead: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px',
    borderBottom: '3px solid #EBEEF3',
    '& img': {
      marginRight: '13px',
      display: 'inline-block',
      flexShrink: '0',
    },
    '& h2': {
      fontSize: '16px',
      fontWeight: '500',
    },
  },
  [theme.breakpoints.up('md')]: {
    Title: {
      fontSize: '24px',
    },
    titleHead: {
      padding: '16px 24px',
      borderRadius: '10px 10px 0 0',
      '& $Title': {
        fontSize: '20px',
      },
    },
    headsubtitle: {
      fontSize: '18px',
    },
    strongText: {
      fontSize: '18px',
    },
    paperCardFrame: {
      marginBottom: '24px',
    },
    innerCardGrid: {
      padding: '24px',
      '& h6': {
        fontSize: '1rem',
      },
    },
    initiateserviceSect: {
      marginBottom: '16px',
      padding: '0',
    },
    pendingLabel: {
      minWidth: '112px',
      fontSize: '14px',
    },
    warrningMessage: {
      justifyContent: 'flex-end',
    },
    notificationbar: {
      '& svg': {
        width: '32px',
      },
    },
    mainBtnholdaer: {
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
  },
  [theme.breakpoints.down('sm')]: {
    notificationArea: {
      margin: '0 auto 12px',
      width: 'calc(100% - 30px)',
    },
    innerModalAccept: {
      '& $crossIconimg': {
        right: '-4px',
      },
      '& h1': {
        marginBottom: '20px',
        fontSize: '16px',
      },
      '& h2': {
        marginBottom: '18px',
        fontSize: '14px',
      },
      '& hr': {
        backgroundColor: '#CED1D6',
      },
    },
    TerminateBtn: {
      fontSize: '14px',
      minWidth: '100px',
      marginRight: '16px',
    },
    modalAccptBtn: {
      fontSize: '14px',
      minWidth: '100px',
    },
  },
  [theme.breakpoints.down('xs')]: {
    mainBtnholdaer: {
      '& $chipHolder': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: '15px',
      },
      '& $downloadBtnoutline': {
        width: '100%',
      },
      '& $pendingLabel': {
        height: 'auto',
        padding: '4px 0',
      },
      '& $warrningMessage': {
        marginLeft: 'auto',
      },
      '& $btnHolder': {
        minWidth: '100%',
      },
    },
    chipHolder: {},
  },
  TitleV2: {
    fontWeight: '600',
    fontSize: '16px',
  },
  headerV2: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      marginBottom: '10px',
      '& img': {
        width: '40px',
      },
    },
  },
  headerContentV2: {
    display: 'flex',
    flexDirection: 'column',
    '& >h1': {
      fontSize: '24px',
      fontWeight: '600',
    },
    '& > img': {
      width: '75px',
    },
    [theme.breakpoints.down('sm')]: {
      '& >h1': {
        fontSize: '12px',
        fontWeight: '500',
      },
      '& >p': {
        fontSize: '12px',
        fontWeight: '500',
      },
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0px',
    },
  },
  imgCls: {
    marginRight: '16px',
  },
  headerImage: {
    width: '100%',
    height: '100px',
    [theme.breakpoints.down('sm')]: {
      width: '72px',
      height: '72px',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '28px',
    display: 'flex',
    gap: '5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  chip: {
    background: '#237E7C',
    borderRadius: '4px',
    color: '#fff',
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    height: '27px',
    fontWeight: '500',
    margin: '6px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 5px',
    },
  },
  subInfo: {
    fontWeight: '600',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  badgeContainer: {
    display: 'flex',
    marginTop: '5px',
  },
  propertyDetailsContainer: {
    display: 'flex',
  },
  approvedToPaymentBar: {
    display: 'flex',
    padding: '12px',
    gap: '8px',
    width: '100%',
    border: '1px solid #005438',
    alignItems: 'center',
    background: '#F3FFFB',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },

  appointmentBar: {
    display: 'flex',
    padding: '12px',
    gap: '8px',
    width: '100%',
    border: '1px solid #08F',
    alignItems: 'center',
    background: '#EBF7FF',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  applicationStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },

  inProgBadge: {
    '& svg circle': {
      fill: theme.palette.primary.adgmInfo,
    },
  },
  draftsBadge: {
    '& svg circle': {
      fill: theme.palette.secondary.dim,
    },
  },
  completedBadge: {
    '& svg circle': {
      fill: theme.palette.primary.successGreenLight,
    },
  },
  rejectedBadge: {
    '& svg circle': {
      fill: theme.palette.primary.main,
    },
  },
  cancelledBadge: {
    '& svg circle': {
      fill: theme.palette.secondary.dim,
    },
  },
  status: {
    color: theme.palette.primary.black80,
  },
  actioner: {
    color: theme.palette.primary.black20,
  },
  cancelBtn: {
    width: '100%',
    border: `1px solid ${theme.palette.primary.main}`,
    color: `${theme.palette.primary.main}`,
    // background: 'transparent',
    fontWeight: '600',
    fontSize: '16px',
    padding: '16px 24px',
    borderRadius: '0px',
    textTransform: 'none',
    '&:hover': {
      border: 'none',
      color: `${theme.palette.primary.white}`,
      background: `${theme.palette.primary.adgmHover}`,
    },
    '& img': {
      marginRight: '5px',
    },
    '& svg': {
      marginRight: '5px',
      fontSize: '19px',
    },
  },
});

export default styles;
